import React from "react";
import { Navigate } from "react-router-dom";

import { UserRole } from "@/auth/types";

import { useAuthContext } from "../hooks/useAuthContext";

type Props = {
  children: React.ReactNode;
  restrictedRoles: UserRole[];
  redirectTo: string;
};

export function RoleGuard({ children, restrictedRoles, redirectTo }: Props) {
  const { user } = useAuthContext();

  const userRole = user?.user_role as UserRole | null;

  if (userRole && restrictedRoles.includes(userRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
